import aetna from "../../css/images/partner/logos/aetna.svg";
import ameritas from "../../css/images/partner/logos/ameritas.png";
import bcbs from "../../css/images/partner/logos/bcbs.png";
import cigna from "../../css/images/partner/logos/cigna.png";
import deltadental from "../../css/images/partner/logos/deltadental.png";
import hartford from "../../css/images/partner/logos/hartford.png";
import humana from "../../css/images/partner/logos/humana.png";
import kemper from "../../css/images/partner/logos/kemper.png";
import lincoln from "../../css/images/partner/logos/lfg.png";
import metlife from "../../css/images/partner/logos/metlife.png";
import principal from "../../css/images/partner/logos/principal.png";
import transamerica from "../../css/images/partner/logos/transamerica.png";
import unitedhealth from "../../css/images/partner/logos/unitedhealthcare.png";
import unum from "../../css/images/partner/logos/unum.png";

let coreServices = [
  {name: 'Consulting & Strategic Planning', text: 'Benefits strategy design, marketplace updates, benchmarking, plan performance reviews, complete benefits program analysis.'},
  {name: 'Vendor Selection & Implementation', text: 'Facilitate vendor selection, provide comprehensive report of vendor proposals, network discount and disruption analysis for self-insured plans, and provide alternative cost of goods sold analysis for clients willing to be on the cutting edge of benefits delivery.'},
  {name: 'Renewal Planning & Negotiation', text: 'Set renewal strategy, evaluate competitiveness of current carrier fees, rates and services, determine need to conduct vendor selection, manage renewal process.'},
  {name: 'Financial Modeling', text: 'Provide plan design options, contribution modeling, cost impact and multi-year projections to support business planning, risk and stop-loss analysis.'},
  {name: 'Vendor & Plan Management', text: 'Manage claim, enrollment, and administrative issues to resolution on behalf of our client and employees.'},
  {name: 'Compliance & Legislative Support', text: 'Ensure that client’s plans are compliant, address legal questions and provide regular compliance updates.'},
  {name: 'Employee Wellness Solutions', text: 'Evaluate and recommend strategy, incentives and vendors for wellness program components if necessary – e.g. biometric screenings, health assessments, corporate wellness challenges, health fairs.'},
  {name: 'Communications & Enrollment', text: 'Develop employee communication materials and benefit technology alternatives, conduct employee enrollment presentations, coordinate annual enrollment process.'}

];

let partnerImgs = [
  {name: 'aetna', src: aetna, href: 'https://www.aetna.com/' },
  {name: 'ameritas', src: ameritas, href: 'https://www.ameritas.com/' },
  {name: 'bcbs', src: bcbs, href: 'https://www.bcbs.com/' },
  {name: 'cigna', src: cigna, href: 'https://www.cigna.com/' },
  {name: 'deltadental', src: deltadental, href: 'https://www.deltadental.com/' },
  {name: 'hartford', src: hartford, href: 'https://www.thehartford.com/' },
  {name: 'humana', src: humana, href: 'https://www.humana.com/' },
  {name: 'kemper', src: kemper, href: 'https://www.kemper.com/' },
  {name: 'lincoln', src: lincoln, href: 'https://www.landoflincolnhealth.org/' },
  {name: 'metlife', src: metlife, href: 'https://www.metlife.com/' },
  {name: 'principal', src: principal, href: 'https://www.principal.com/' },
  {name: 'transamerica', src: transamerica, href: 'https://www.transamerica.com/' },
  {name: 'unitedhealth', src: unitedhealth, href: 'https://www.myuhc.com' },
  {name: 'unum', src: unum, href: 'https://www.unum.com/' }
];

export {coreServices, partnerImgs};



// WEBPACK FOOTER //
// ./src/components/partner-slider/config.js